/* eslint-disable import/prefer-default-export */
/* eslint-disable consistent-return */
import { apileads } from '../enviroment/apileads';

const getUnidadNegocio = async () => {
  const response = await apileads.get('/v1/unidad-negocio');
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log('Error get List ');
  }
};

export {
    getUnidadNegocio,
};
